<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g data-name="Ico_list view" ><path data-name="합치기 386" d="M19377.531-2761a1 1 0 0 1-1-1v-1.119a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1.119a1 1 0 0 1-1 1zm0-4.769a1 1 0 0 1-1-1v-7.227a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7.227a1 1 0 0 1-1 1z" transform="translate(-19375.533 2775.996)" /></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-list-view-new',
});
</script>